// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"8e3cb7d8","216":"31d6cfe0","266":"fa3fa210","610":"52b80868","619":"5450f9c8","668":"38eb8d4a","763":"57c80b4c"}[chunkId] + ".chunk.css";
};